import LoadingBar from '../helperComponents/LoadingBar'
import errorHandler from '@/ft-vue-core/mixins/errorHandler'
import ApiErrors from '@/ft-vue-core/components/ApiErrors'
import LockTimer from '@/ft-vue-core/components/LockTimer'
import LeftSidePanelHeader from '../helperComponents/LeftSidePanelHeader'
import SimpleExpansionCard from '../helperComponents/SimpleExpansionCard'
import TableNamesCard from '../helperComponents/TableNamesCard'
import headerMethods from '@/ft-vue-core/mixins/headerMethods'
import ServerInitialIcon from '../helperComponents/ServerInitialIcon'
function* getUniqueKey () {
  for (let i = 0;; i++) yield 'generated-key-' + i
}
export default {
  components: {
    LoadingBar, 
    ApiErrors, 
    LockTimer, 
    LeftSidePanelHeader, 
    SimpleExpansionCard, 
    TableNamesCard,
    ServerInitialIcon,
  },
  mixins: [errorHandler, headerMethods],
  data () {
    return {
      awaitingApiResponse: 0,
      keyGenerator: getUniqueKey()
    }
  },
  methods: {
    setAwaitingApiResponse (val) {
      this.awaitingApiResponse += val ? 1 : -1
    }
  }
}